export function isAccessor(value) {
    return typeof value === 'function';
}
export function isReactiveAccessor(value) {
    if (!isAccessor(value)) {
        return false;
    }
    const maybeReactive = value;
    return maybeReactive.__isSignal === true || maybeReactive.__isComputed === true;
}
export function readReactiveAccessor(value) {
    return value.peek();
}
export function readMaybeAccessor(value) {
    return isAccessor(value) ? value() : value;
}
//# sourceMappingURL=accessor.js.map